export class MailDto {
    typeUseCase: TypeUseCase
    sentCount: number
    lastSentDate: string
}

export enum TypeUseCase {
    UC0 = 'UC0',
    UC1 = 'UC1',
    UC1_REL = 'UC1_REL',
    UC2 = 'UC2',
    UC3 = 'UC3',
    UC4_ABORT = 'UC4_ABORT',
}

export const typeUseCases: { code: TypeUseCase; label: string }[] = [
    { code: TypeUseCase.UC0, label: 'Mail intervenant manquant' },
    { code: TypeUseCase.UC1, label: 'Mail demande de lancement' },
    { code: TypeUseCase.UC1_REL, label: 'Mail dernière demande de lancement' },
    { code: TypeUseCase.UC2, label: 'Mail confirmation de lancement' },
    { code: TypeUseCase.UC3, label: 'Mail refus de lancement' },
    { code: TypeUseCase.UC4_ABORT, label: "Mail abandon de l'enquête" },
]

export function getTypeUseCaseName(typeUseCase: TypeUseCase) {
    return typeUseCases.find((value) => value.code === typeUseCase)?.label
}
